import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { PieChartConfig } from '../GCharts/PieChartConfig';
import { saveAs as importedSaveAs } from "file-saver";


import { ReporteViaje } from '../Models/ReporteViaje';
import { Usuario } from '../Models/Usuario';
import { Vehiculo } from '../Models/Vehiculo';
import { Pago } from '../Models/Pago';

import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { UsuarioService } from '../services/usuario.service';
import { VehiculoService } from '../services/vehiculo.service';
import { ViajeService } from '../services/viaje.service';
import { UtilesService } from '../services/utiles.service';
import {  GeneradorTemplateService } from '../services/generador-template.service';

import { ReportePagosEfectuados } from '../Models/ReportePagosEfectuados';

@Component({
  selector: 'app-reporte-pago',
  templateUrl: './reporte-pago.component.html',
  styleUrls: ['./reporte-pago.component.css']
})
export class ReportePagoComponent implements OnInit {


  public reporteViaje: ReporteViaje = new ReporteViaje();
  public reporteViajes: ReporteViaje[];

  public nombreUsuario: string;
  public nombrePunto: string;
  public idVehiculo: string;
  public fechaInicio: Date;
  public fechaFin: Date;

  public montoTotal: number;
  public montoTotalContado: number;
  public montoTotalCheque: number;
  public montoTotalTranferencia: number;
  public montoTotalTarjeta: number;


  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];


  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];


  public pago: ReportePagosEfectuados = new ReportePagosEfectuados();
  public pagos: ReportePagosEfectuados[];

  public pagosContado: ReportePagosEfectuados[];
  public pagosCheque: ReportePagosEfectuados[];
  public pagosTransferencias: ReportePagosEfectuados[];
  public pagosTarjeta: ReportePagosEfectuados[];



  public mostrarPago: boolean = false;


  constructor(private reporteService: ReporteViajeService, private globalServices: GlobalsService,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService, private viajeService: ViajeService,
    private utilesService:UtilesService,
    private generadorTemplate:GeneradorTemplateService) {

  }


  ngOnInit() {

    this.CargarVehiculos();
    this.CargarUsuarios();

  }



  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }



  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }




  CargarReporteViajes() {
    try {
      if (this.usuario.idUsuario === undefined || this.usuario.idUsuario === "") {
        this.usuario.idUsuario = null;
      }

      if (this.vehiculo.idvehiculo === undefined || this.vehiculo.idvehiculo === "") {
        this.vehiculo.idvehiculo = null;
      }
      if (this.fechaInicio === null) {
        this.fechaInicio = undefined;
      }

      if (this.fechaInicio === undefined || this.fechaInicio.toString() == "") {
        this.fechaInicio = null;
      }

      if (this.fechaFin === null) {
        this.fechaFin = undefined;
      }

      if (this.fechaFin === undefined || this.fechaFin.toString() == "") {
        this.fechaFin = null;
      }

      this.nombrePunto = null;

      this.reporteService.ObtenerReporteViaje(this.globalServices.ObtenerCompania(), this.usuario.idUsuario, this.nombrePunto
        , this.vehiculo.idvehiculo, this.fechaInicio,
        this.fechaFin).subscribe(
          data => {
            this.reporteViajes = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("cargar reporte viajes: " + error);
    }

  }



  RegistroSeleccionado(item) {

    this.reporteViaje = JSON.parse(JSON.stringify(item));

    this.CargarPagos(this.reporteViaje.idViaje);

  }


  CargarPagos(idViaje: string) {
    try {

      let monto: number = 0;
      let montoEfectivo: number = 0;
      let montoTranferencia: number = 0;
      let montoTarjeta: number = 0;
      let montoCheque: number = 0;

      this.viajeService.ObtenerPagoViaje(this.globalServices.ObtenerCompania(), idViaje).subscribe(
        data => {
          this.pagos = data;
          this.usuario;

          this.pagosContado = [];
          this.pagosTransferencias = [];
          this.pagosTarjeta = [];
          this.pagosCheque = [];

          this.pagos.forEach(element => {
            monto = monto + element.monto;

            if (element.tipoPago.toLowerCase() === "contado") {
              this.pagosContado.push(element);
              montoEfectivo = montoEfectivo + element.monto;
            }

            if (element.tipoPago.toLowerCase() === "tarjeta") {
              this.pagosTarjeta.push(element);
              montoTarjeta = montoTarjeta + element.monto;
            }

            if (element.tipoPago.toLowerCase() === "transferencia") {
              this.pagosTransferencias.push(element);
              montoTranferencia = montoTranferencia + element.monto;
            }

            if (element.tipoPago.toLowerCase() === "cheque") {
              this.pagosCheque.push(element);
              montoCheque = montoCheque + element.monto;
            }

          });

          this.montoTotal = monto;
          this.montoTotalContado = montoEfectivo
          this.montoTotalCheque = montoCheque;
          this.montoTotalTarjeta = montoTarjeta;
          this.montoTotalTranferencia = montoTranferencia;
          this.mostrarPago = true;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarPagos: " + error);
    }

  }


  Regresar() {
    this.mostrarPago = false;
  }




/**
 * Metodo que descarga el reporte
 */
DescargarReporte() {


    //nombre que va a tener el archivo
    var nombre =  "reporte liquidacion valores";
    var archivo = this.utilesService.getURLReportes() + nombre + ".pdf" ;
  
    //Genera el arciho PDF en la api
    this.generadorTemplate.ReportePago(this.globalServices.ObtenerCompania(), this.reporteViaje.idViaje, nombre ).subscribe(
      res => {
       
        if(res.tipoResultado==="ERROR"){
          swal("Error, "+ res.mensaje, "", "error");
            return
        }

        var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
        var fileName = "Reporte Liquidación de Valores.pdf";

        importedSaveAs(resultado, fileName);
      }
    )
  }

}
